// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function () {
	"use strict";

	/*
	Info Button Directive
	*/

	angular.module("swurveys.maker")
		.directive("swvBinaryToggle", Handler)

	function Handler(utilsService) {
		return {
			restrict: 'E',
			replace: true,
			require: 'ngModel',
			transclude: true,
      scope: {
				ngModel: '=',
				ngChange: '=',
				ngDisabled: '=',
				swvLabel: '@',
				swvInfo: '@'
			},
			link : function(scope) {
				scope.id = utilsService.generateUUID();
			},
			template: '\
  <div class="row toggle-row">\
    <div class="col-xs-12">\
      <div class="pull-left">\
        <p>\
				<info-button ng-if="swvInfo">{{swvInfo}}</info-button>\
          <span ng-bind-html="swvLabel"></span> <ng-transclude /> </p>\
        </div>\
        <div class="onoffswitch pull-right">\
          <input type="checkbox"\
          name="onoffswitch"\
          class="onoffswitch-checkbox"\
          id="{{id}}"\
					ng-disabled="ngDisabled"\
					ng-change="ngChange"\
          ng-model="ngModel">\
          <label\
          class="onoffswitch-label"\
          for="{{id}}">\
            <span class="onoffswitch-inner"></span>\
            <span class="onoffswitch-switch"></span>\
          </label>\
      </div>\
    </div>\
  </div>'
		}
	}

}());
